// Functions for formatting amount
export const useAmountFormat = (amount?: number, minimumFractionDigits = 3, maximumFractionDigits = 3) => {
  if (!amount) {
    return 'N/A';
  }
  const { locale } = useI18n();

  return new Intl.NumberFormat(locale.value, {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(amount);
};
